import { useInfiniteQuery } from '@tanstack/react-query';
import type { AdminActivityCursor } from '@casetrace/shared';
import { listAdminActivity } from '../lib/admin-callables';

export function useAdminActivity() {
  return useInfiniteQuery({
    queryKey: ['admin-activity'],
    queryFn: ({ pageParam }) => listAdminActivity(pageParam),
    initialPageParam: undefined as AdminActivityCursor | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  });
}
